import styled from 'styled-components';
import { FloatInput } from './FloatInput';
import { lineHeight } from '../../../../style';

export const WeightInput = styled(FloatInput)`
  width: ${4 * lineHeight}px;
  background: var(--input-highlighted-color);
`;
